<template>
    <div>
        <v-dialog v-model="staffReviewerDialog" max-width="900px">
          <v-card>
            <v-card-text>
              <v-container>
                    <v-row>
                        <span style="font-weight: bold;" class="mb-2 mt-6">{{$t('performancemanagement.createnewkpisetting')}}</span>
                    </v-row>

                    <div>
                        <v-row class="pb-n4 mb-n4 mt-6">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.name')"
                                type="text"
                                v-model="staffReviewerData.staffid"
                                dense
                                :items="filteredStaffList"
                                @input="updateValue"
                                @change="changeStaff(staffReviewerData.staffid)"
                            ></v-autocomplete>
                        </v-row>

                        <v-row class="pb-n4 mt-n8">
                            <v-col cols="4" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.staffid')"
                                    type="text"
                                    v-model="staffReviewerData.staffcode"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.company')"
                                    type="text"
                                    v-model="staffReviewerData.staffcompany"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                    <div>
                        <v-row class="pb-n4 mb-n4">
                            <v-autocomplete
                                outlined
                                :label="$t('appraisalrecord.reviewer')"
                                type="text"
                                v-model="staffReviewerData.reviewerid"
                                dense
                                :items="filteredReviewerList"
                                @input="updateValue"
                                @change="changeReviewer(staffReviewerData.reviewerid)"
                            ></v-autocomplete>
                        </v-row>

                        <v-row class="pb-n4 mt-n8">
                            <v-col cols="4" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.staffid')"
                                    type="text"
                                    v-model="staffReviewerData.reviewercode"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.company')"
                                    type="text"
                                    v-model="staffReviewerData.reviewercompany"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="savestaffReviewerDialog">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closestaffReviewerDialog">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-container style="max-width:100%;padding-left:0;padding-right:0;overflow-x:auto;" class="overflow-y-auto">
            <v-row class="mt-4">
                <v-col cols="12" class="pb-n5 mt-n8">
                    <v-toolbar flat>
                        <v-row align="center" no-gutters>
                            <v-col cols="auto">
                                <v-btn v-if="!parentObject.isWizard" class="ml-0" color="primary" dark @click="openstaffReviewerDialog">+</v-btn>
                            </v-col>
                            <v-col cols="auto" class="ml-2"> 
                                <v-btn v-if="!parentObject.isWizard" color="primary" dark @click="initiateWorkflow">{{ $t('performancemanagement.initiateworkflow') }}</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="3" class="mr-3">
                                <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Search"
                                    single-line
                                    hide-details
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <div class="export-icon-btns">
                                <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF" title="Export PDF">
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
                                  PDF
                                </button>
                                <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                                  CSV
                                </button>
                            </div>
                        </v-row>
                    </v-toolbar>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="this.parentObject.tabHeader"
                        :items="detailItem"
                        :search="search"
                        class="elavation-1"
                        fixed-header
                        :sort-by="['code']"
                    >
                        <template v-if="!parentObject.isWizard" v-slot:[`item.action`]="{ item }">
                            <v-icon
                                small
                                class="ml-2 mr-2"
                                @click="modifyItemHandler(item)"
                            >
                                mdi-pen
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteItemHandler(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>

        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
        <div v-if="isSuccess">
        <app-success
            v-bind:parentObject="{
                messageSuccess: this.successMsg,
                isSuccess: this.isSuccess,
            }"
            @close-success="goBackToGrid"
        />
        </div>
        <v-overlay :value="isInitiatingWorkflow">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import SuccessDialog from "../../../components/common/SuccessDialog";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
        "app-success": SuccessDialog
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,

            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            id: this.$route.params.id,

            formData: this.parentObject.formData,

            staffReviewerData: {
                staffid: null,
                staffcode: null,
                staffcompany: null,
                reviewerid: null,
                reviewercode: null,
                reviewercompany: null,
                kpirecstatusid: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            dataItems: this.parentObject.detailItem,
            title: this.parentObject.pageTitle,
            titleValue: this.parentObject.pageTitleValue,

            staffFull: [],
            staffList: [],

            staffReviewerDialog: false,
            detailItem: this.parentObject.detailItem,

            statusList: [],
            search: '',

            //error msg and dialog, check for duplicates vars
            isErr: false,
            errMsg: '',
            isSuccess: false,
            successMsg: '',
            isInitiatingWorkflow: false,
        }
    },

    computed: {
        filteredStaffList() {
            // Filter out the selected reviewer from the Name field's options
            return this.staffList.filter(staff => staff.value !== this.staffReviewerData.reviewerid);
        },
        filteredReviewerList() {
            // Filter out the selected staff from the Reviewer field's options
            return this.staffList.filter(staff => staff.value !== this.staffReviewerData.staffid);
        }
    },

    methods: {
        modifyItemHandler(item) {
            this.$router.push({ name: "kpisettingstaffexercise", params: { id: item.id, form: this.formData, item: item} });
        },

        deleteItemHandler(item){
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm(this.$t('pmreviewexercise.deletestaff'))) {
                this.$store.dispatch('delete', {
                    url: "/kpiexercisestaff/" + item.id + '/' + this.$store.getters.userId + '/' + item.kpiexerid + '/' +item.kpiexerrecstatus
                })
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    window.location.reload();
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
            }
        },

        openstaffReviewerDialog() {
            this.staffReviewerDialog = true;
        },

        savestaffReviewerDialog() {
            const vm = this;

            let filteredStatus = vm.statusList.find(item => item.kpiexerrecstatus === "OPEN");
            vm.staffReviewerData.kpirecstatusid = filteredStatus.id;

            this.$store.dispatch('post', {url: "/kpiexercisestaff/create/" + vm.id, payload: vm.staffReviewerData})
            .then((res) => {
                if (res.data.error) {
                    if (Array.isArray(res.data.error)) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = res.data.error.join(", ");
                    } else {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = res.data.error;
                    }
                } else {
                    // Refresh the page
                    window.location.reload();
                }
            })
            .catch((err) => {
                if (Array.isArray(err)) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err.join(", ");
                } else {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                }
            });
                
                
            // reset the form fields
            this.staffReviewerDialog = false;
            this.resetSelections();
        },

        closestaffReviewerDialog() {
            this.staffReviewerDialog = false;
            this.isErr = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.staffReviewerData = {
                staffid: null,
                staffcode: null,
                staffcompany: null,
                reviewerid: null,
                reviewercode: null,
                reviewercompany: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
        },

        updateValue() {
            this.$emit("input", {
                staffid: this.staffReviewerData.staffid,
                staffcode: this.staffReviewerData.staffcode,
                staffcompany: this.staffReviewerData.staffcompany,
                reviewerid: this.staffReviewerData.reviewerid,
                reviewercode: this.staffReviewerData.reviewercode,
                reviewercompany: this.staffReviewerData.reviewercompany,
                stamp: 0,
                userid: this.$store.getters.userId,
            });
        },

        loadStaffList(){
            const vm = this;
            const today = new Date();

            this.$store.dispatch('get', {url: "/staff/all/" + this.$store.getters.userId})
            .then((res) => {

                const staffRecords = res.data.rec;

                // Filter staff records where cessadate > today's date
                const filteredStaff = staffRecords.filter(staff => {
                    const cessadate = new Date(staff.cessadate);
                    return cessadate > today;
                });

                vm.staffFull = filteredStaff;

                // Populate staffList with filtered data
                vm.staffList = filteredStaff.map(staff => ({
                    text: staff.psndetails,
                    value: staff.id,
                }));
                
            }).catch((err) => {
                console.error(err)
            });

        },

        changeStaff(id) {
            let item = this.staffFull.find((item) => item.id === id);
            this.staffReviewerData.staffcode = item?.staffcode ?? null;
            this.staffReviewerData.staffcompany = item?.compnycode ?? null;
        },

        changeReviewer(id) {
            let item = this.staffFull.find((item) => item.id === id);
            this.staffReviewerData.reviewercode = item?.staffcode ?? null;
            this.staffReviewerData.reviewercompany = item?.compnycode ?? null;
        },

        async fetchStatusRec() {

            const vm = this;

            // Dispatch the post request with the payloads object
            await this.$store.dispatch('get', {url: "/kpiexerciserecstatus/all"})
            .then((res) => {

            if (res.status == 200) {

                vm.statusList = res.data.rec;

            } else {
                vm.isErr = !vm.isErr;
            }
            })
            .catch((err) => {
                console.log(err);
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });

        },

        printPDF() {
            const doc = new jsPDF({
                orientation: "landscape",
            });

            var head = [
                { title: this.$t('columns.staffcode'),  dataKey: 'staffcode'},
                { title: this.$t('columns.name'),  dataKey: 'staffname'},
                { title: this.$t('appraisalrecord.reviewer'), dataKey: "reviewercode"},
                { title: this.$t('appraisalrecord.reviewername'), dataKey: "reviewername"},
                { title: this.$t('columns.periodstartdate'), dataKey: "periodstartdate"},
                { title: this.$t('columns.periodenddate'), dataKey: "periodenddate" },
                { title: this.$t('columns.company'), dataKey: "compnycode" },
                { title: this.$t('columns.branch'), dataKey: "brchcode" },
                { title: this.$t('columns.department'), dataKey: "deptcode" },
                { title: this.$t('columns.section'), dataKey: "sectiocode" },
                { title: this.$t('columns.unit'), dataKey: "unitcode" },
                { title: this.$t('columns.grade'), dataKey: "grdcode" },
                { title: this.$t('columns.position'), dataKey: "poscode" },
                { title: this.$t('performancemanagement.createddate'), dataKey: "createdate" },
                { title: this.$t('performancemanagement.completeddate'), dataKey: "completedate" },
            ];

            let body = [];
                for (var i = 0; i < this.dataItems.length; i++) {
                body.push({
                staffcode: this.dataItems[i].staffcode,
                staffname: this.dataItems[i].staffname,
                reviewercode: this.dataItems[i].reviewercode,
                reviewername: this.dataItems[i].reviewername,
                periodstartdate: this.dataItems[i].periodstartdate,
                periodenddate: this.dataItems[i].periodenddate,
                compnycode: this.dataItems[i].compnycode,
                brchcode: this.dataItems[i].brchcode,
                deptcode: this.dataItems[i].deptcode,
                sectiocode: this.dataItems[i].sectiocode,
                unitcode: this.dataItems[i].unitcode,
                grdcode: this.dataItems[i].grdcode,
                poscode: this.dataItems[i].poscode,
                createdate: this.dataItems[i].createdate,
                completedate: this.dataItems[i].completedate,
                });
            }

            doc.text(
                `${this.title} ${this.titleValue}`,
                10,
                10
            );

            doc.autoTable({
                head: [head.map(col => col.title)], // Extract titles
                body: body.map(row => Object.values(row)), // Extract values
                columnStyles: {
                    // You can set fixed widths per column key
                    staffcode: { cellWidth: 20 },
                    staffname: { cellWidth: 35 },
                    reviewercode: { cellWidth: 25 },
                    reviewername: { cellWidth: 35 },
                    periodstartdate: { cellWidth: 30 },
                    periodenddate: { cellWidth: 30 },
                    compnycode: { cellWidth: 20 },
                    brchcode: { cellWidth: 20 },
                    deptcode: { cellWidth: 20 },
                    sectiocode: { cellWidth: 20 },
                    unitcode: { cellWidth: 20 },
                    grdcode: { cellWidth: 20 },
                    poscode: { cellWidth: 20 },
                    createdate: { cellWidth: 30 },
                    completedate: { cellWidth: 30 },
                },
                startY: 20, // to leave space for the title
                styles: {
                    fontSize: 6, // optional: reduce text size to help fit columns
                    cellPadding: 1,
                }
            });

            doc.save("KPI Setting Report " + "- " + this.parentObject.pageTitleValue + ".pdf");
        },

        async getCSV() {
            let item = this.dataItems;
            let data = [];

            for (var i = 0; i < item.length; i++) {
                data.push({
                [`${this.$t('columns.staffcode')}`]: item[i].staffcode,
                [`${this.$t('columns.name')}`]: item[i].staffname,
                [`${this.$t('appraisalrecord.reviewer')}`]: item[i].reviewercode,
                [`${this.$t('appraisalrecord.reviewername')}`]: item[i].reviewername,
                [`${this.$t('columns.periodstartdate')}`]: item[i].periodstartdate,
                [`${this.$t('columns.periodenddate')}`]: item[i].periodenddate,
                [`${this.$t('columns.company')}`]: item[i].compnycode,
                [`${this.$t('columns.branch')}`]: item[i].brchcode,
                [`${this.$t('columns.department')}`]: item[i].deptcode,
                [`${this.$t('columns.section')}`]: item[i].sectiocode,
                [`${this.$t('columns.unit')}`]: item[i].unitcode,
                [`${this.$t('columns.grade')}`]: item[i].grdcode,
                [`${this.$t('columns.position')}`]: item[i].poscode,
                [`${this.$t('performancemanagement.createddate')}`]: item[i].createdate,
                [`${this.$t('performancemanagement.completeddate')}`]: item[i].completedate,
                });
            }

            const csvData = this.objectToCSV(data);
            this.download(csvData);
        },

        objectToCSV(data) {
            const csvRows = [];

            // get header
            const headers = Object.keys(data[0]);
            csvRows.push(headers.join(","));

            // loop over the rows
            for (const row of data) {
                const values = headers.map((header) => {
                const escaped = ("" + row[header]).replace(/"/g, '\\"');
                return `"${escaped}"`;
                });
                csvRows.push(values.join(","));
            }
            return csvRows.join("\n");
            },

        download(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");

            a.setAttribute("hidden", "");
            a.setAttribute("href", url);
            a.setAttribute(
                "download",
                "KPI Setting Report " + "-" + this.parentObject.pageTitleValue + ".csv"
            );

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },

        async initiateWorkflow() {
            //Only proceed if KPI Exercise Status == OPEN and isInitiatedWorkflow == false, if not send error message 

            const vm = this;

            vm.isInitiatingWorkflow = true;

            if (vm.formData.kpiexerstatus !== "OPEN") {
                vm.isErr = true;
                vm.errMsg = vm.$t('performancemanagement.kpiexerstatusnotopen');
                vm.isInitiatingWorkflow = false;
                return;
            }

            if (vm.formData.isInitiateWorkflow === 1) {
                vm.isErr = true;
                vm.errMsg = vm.$t('performancemanagement.workflowalreadyinitiated');
                vm.isInitiatingWorkflow = false;
                return;
            }

            // Proceed if OPEN + Not Yet initiated
            try {
                const data = vm.dataItems.map(d => ({
                    ...d,
                    staffFirst: vm.formData.staffFirst,
                    stamp: vm.staffReviewerData.stamp,
                    updatedby: vm.staffReviewerData.userid
                }));

                const res = await this.$store.dispatch('post', { url: "/rbwftran/create/" + this.formData.kpiexerstatusid, payload: data });

                if (res.status === 201) {
                    console.log("RESWFTRAN", res);
                    vm.isSuccess = true;
                    vm.successMsg = vm.$t('performancemanagement.workflowinitiated');
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error || res.data.message || 'An unexpected error occurred.';
                }
            } catch (err) {
                console.error('Error in generateWfTran:', err);
                vm.isErr = true;
                vm.errMsg = err.message || String(err);
            } finally {
                vm.isInitiatingWorkflow = false;
            }
        },

        goBackToGrid() {
            this.isSuccess = false;
            this.$router.push({ name: "kpisettinglist" });
        }
    },

    mounted() {
        this.loadStaffList();
        this.fetchStatusRec();
    }
}
</script>

<style scoped>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}

.mdi-delete::before {
    margin-top: -8px;
}

.mdi-pen::before {
  margin-top: -8px;
}

.export-icon-btns { display: flex; gap: 8px; align-items: center; }
.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s;
}
.export-icon-pdf { background: #FEF2F2; color: #DC2626; border: 1px solid #FECACA; }
.export-icon-pdf:hover { background: #DC2626; color: #fff; border-color: #DC2626; }
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; border-color: #059669; }

</style>